module.exports = __webpack_public_path__ + "img/250_old.a06e5e66.png";